<template>
    <form class="na-form faq" @submit="onSaveNewFaq($event)" ref="form">
        <div v-if="accessList._300624">
            <div class="btn-add-edit">
                <DxButton icon="far fa-plus-square feedIcon" styling-mode="text" :text="btn.AddNewFaqBtn" class="feedIconBtn" @click="updateFaqList" />
                <DxButton icon="fas fa-pen editIcon" styling-mode="text" :text="btn.EditFaqBtn" class="editIcon" @click="edit" />
            </div>
           
            <DxSelectBox :show-clear-button="false"
                         :data-source="areas"
                         displayExpr="FaaName"
                         v-model:value="FaaId"
                         value-expr="FaaId">
                <DxValidator>
                    <DxRequiredRule message=" " />
                </DxValidator>
            </DxSelectBox>
            <DxPopup v-model:visible="addFaqVisible"
                     :drag-enabled="false"
                     :close-on-outside-click="true"
                     :show-close-button="false"
                     :show-title="true"
                     :min-width="500"
                     :min-height="500"
                     title="Add new Wiki Article">
                <DxPosition at="center"
                            my="center"
                            v-model:of="window" />
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="before"
                               :options="cancelAddFaqOptions" />
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="after"
                               :options="addFaqButtonOptions" />
                <div class="rfbAddFAqPopupBox">
                    <DxValidationGroup ref="addFaqValidationGroup">
                    <div class="rfbAddFAqForm">
                        <div class="addFaqLabel">Group Name</div>
                        <DxSelectBox :show-clear-button="true"
                                     :accept-custom-value="true"
                                     :data-source="groups"
                                     displayExpr="FagName"
                                     v-model:selectedItem="fagValue"
                                     v-model:text="fagName"
                                     v-model:value="faqData.FagId"
                                     value-expr="FagId"
                                     :placeholder="placeholders.Group"
                                     @customItemCreating="onCustomItemCreating"
                                     @value-changed="onGroupValueChanged"
                                     @selection-changed="onGroupSelectionChanged">
                            <DxValidator ref="groupValidator">
                                <DxCustomRule :message="validation.GroupRequired"
                                              :validation-callback="() => !!(fagName && fagName.trim())" />
                            </DxValidator>
                        </DxSelectBox>
                        <div class="addFaqLabel">Term</div>
                        <div class="addFaqValue">
                            <DxTextBox v-model:value="faqData.FaqName" :placeholder="placeholders.Term">
                                <DxValidator>
                                    <DxRequiredRule :message="validation.TermRequired" />
                                </DxValidator>
                            </DxTextBox>
                        </div>
                        <div class="addFaqLabel">Description</div>
                        <div class="addFaqValue">
                            <DxHtmlEditor v-model:value="faqData.FaqAnswer"
                                          height="400">
                                <DxMediaResizing :enabled="true" />
                                <DxImageUpload :tabs="currentTabs"
                                               file-upload-mode="base64" />
                                <DxToolbar :multiline="isMultiline">
                                    <DxItem name="undo" />
                                    <DxItem name="redo" />
                                    <DxItem name="separator" />
                                    <!--<DxItem :accepted-values="sizeValues"
                                            name="size" />
                                    <DxItem :accepted-values="fontValues"
                                            name="font" />
                                    <DxItem name="separator" />-->
                                    <DxItem name="bold" />
                                    <DxItem name="italic" />
                                    <DxItem name="strike" />
                                    <DxItem name="underline" />
                                    <!--<DxItem name="separator" />
                                    <DxItem name="alignLeft" />
                                    <DxItem name="alignCenter" />
                                    <DxItem name="alignRight" />
                                    <DxItem name="alignJustify" />-->
                                    <DxItem name="separator" />
                                    <DxItem name="orderedList" />
                                    <DxItem name="bulletList" />
                                    <DxItem name="separator" />
                                    <!--<DxItem :accepted-values="headerValues"
                                            name="header" />
                                    <DxItem name="separator" />
                                    <DxItem name="color" />
                                    <DxItem name="background" />
                                    <DxItem name="separator" />-->
                                    <DxItem name="link" />
                                    <!--<DxItem name="image" />-->
                                    <!--<DxItem name="separator" />
                                    <DxItem name="clear" />
                                    <DxItem name="codeBlock" />
                                    <DxItem name="blockquote" />
                                    <DxItem name="separator" />
                                    <DxItem name="insertTable" />
                                    <DxItem name="deleteTable" />
                                    <DxItem name="insertRowAbove" />
                                    <DxItem name="insertRowBelow" />
                                    <DxItem name="deleteRow" />
                                    <DxItem name="insertColumnLeft" />
                                    <DxItem name="insertColumnRight" />
                                    <DxItem name="deleteColumn" />-->
                                </DxToolbar>
                                <DxValidator>
                                    <DxRequiredRule :message="validation.DescriptionRequired" />
                                </DxValidator>
                            </DxHtmlEditor>
                        </div>
                    </div>
                    </DxValidationGroup>
                </div>
            </DxPopup>
            <DxButton id="submitButton" ref="submitButton" useSubmitBehavior="true" style="visibility: hidden;"></DxButton>

        </div>

        <div v-for="fag in groups" :key="fag.FagId" class="faqPage">
            <div class="faqGroupTitle">
                <div v-if="!canEdit">
                    {{ fag.FagName }}
                </div>
                <div v-if="canEdit">
                    <div class="fagRecord">
                        <div class="fagPosition">
                            <DxNumberBox v-model:value="fag.FagPosition" @change="update" width="50"></DxNumberBox>
                        </div>
                        <div class="fagName">
                            <DxTextBox v-model:value="fag.FagName" @change="update"></DxTextBox>
                        </div>
                        <div class="fagDeleted">
                            <DxButton @click="deleteFag(fag)" icon="fal fa-trash"></DxButton>
                        </div>
                    </div>
                </div>
            </div>
            <div class="faqList">
                <DxAccordion :data-source="getData(fag.FagId)"
                             key-expr="FaqId"
                             :collapsible="true"
                             :multiple="false"
                             :animation-duration="500"
                             :selected-item-keys="['x']"
                             id="accordion-container">
                    <template #title="{ data }">
                        <div v-if="!canEdit">
                            {{ data.FaqName }}
                        </div>
                        <div v-if="canEdit" class="faqNameRecord">
                            <div class="faqPosition">
                                <DxNumberBox v-model:value="data.FaqPosition" @change="update"></DxNumberBox>
                            </div>
                            <div class="faqName">
                                <DxTextBox v-model:value="data.FaqName" @change="update"></DxTextBox>
                            </div>
                        </div>
                    </template>
                    <template #item="{ data }">
                        <div v-if="!canEdit" v-html="data.FaqAnswer">
                        </div>
                        <div v-if="canEdit">
                            <div class="faqRecord">
                                <div class="faqAnswer">
                                    <!--<DxTextArea v-model:value="data.FaqAnswer" @change="update"></DxTextArea>-->
                                    <DxHtmlEditor v-model:value="data.FaqAnswer"
                                                  height="400">
                                        <DxMediaResizing :enabled="true" />
                                        <DxImageUpload :tabs="currentTabs"
                                                       file-upload-mode="base64" />a
                                        <DxToolbar :multiline="isMultiline">
                                            <DxItem name="undo" />
                                            <DxItem name="redo" />
                                            <DxItem name="separator" />
                                            <!--<DxItem :accepted-values="sizeValues"
                                                    name="size" />
                                            <DxItem :accepted-values="fontValues"
                                                    name="font" />
                                            <DxItem name="separator" />-->
                                            <DxItem name="bold" />
                                            <DxItem name="italic" />
                                            <DxItem name="strike" />
                                            <DxItem name="underline" />
                                            <!--<DxItem name="separator" />
                                            <DxItem name="alignLeft" />
                                            <DxItem name="alignCenter" />
                                            <DxItem name="alignRight" />
                                            <DxItem name="alignJustify" />-->
                                            <DxItem name="separator" />
                                            <DxItem name="orderedList" />
                                            <DxItem name="bulletList" />
                                            <DxItem name="separator" />
                                            <!--<DxItem :accepted-values="headerValues"
                                                    name="header" />
                                            <DxItem name="separator" />
                                            <DxItem name="color" />
                                            <DxItem name="background" />
                                            <DxItem name="separator" />-->
                                            <DxItem name="link" />
                                            <!--<DxItem name="image" />-->
                                            <!--<DxItem name="separator" />
                                            <DxItem name="clear" />
                                            <DxItem name="codeBlock" />
                                            <DxItem name="blockquote" />
                                            <DxItem name="separator" />
                                            <DxItem name="insertTable" />
                                            <DxItem name="deleteTable" />
                                            <DxItem name="insertRowAbove" />
                                            <DxItem name="insertRowBelow" />
                                            <DxItem name="deleteRow" />
                                            <DxItem name="insertColumnLeft" />
                                            <DxItem name="insertColumnRight" />
                                            <DxItem name="deleteColumn" />-->
                                        </DxToolbar>
                                    </DxHtmlEditor>
                                </div>


                                <div class="btn-html-editor">
                                    <div class="faqEnabled">
                                        <DxCheckBox v-model:value="data.FaqEnabled" @valueChanged="update" :text="btn.ReleasedSelect"></DxCheckBox>
                                    </div>
                                    <div class="faqDeleted">
                                        <DxButton @click="deleteFaq(data)" :text="btn.DeleteBtn" styling-mode="text" icon="fal fa-trash"></DxButton>
                                    </div>
                                    <div class="faqSave">
                                        <DxButton @click="update" :text="btn.SaveBtn" styling-mode="text" icon="fal fa-floppy-disk"></DxButton>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </template>
                </DxAccordion>
            </div>
        </div>
    </form>
</template>

<script>

    import DxAccordion from 'devextreme-vue/accordion';
    import DxCheckBox from 'devextreme-vue/check-box';
    //import DxTextArea from 'devextreme-vue/text-area';
    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxNumberBox } from 'devextreme-vue/number-box'
    import { DxButton } from 'devextreme-vue/button';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup'
    import DataSource from 'devextreme/data/data_source';
    import { confirm } from 'devextreme/ui/dialog';
    import DxValidationGroup from 'devextreme-vue/validation-group';
    import {
        DxValidator,
        DxRequiredRule,
        DxCustomRule,
        //DxCompareRule,
        //DxEmailRule,
        //DxPatternRule,
        //DxStringLengthRule,
        //DxRangeRule,
        //DxAsyncRule,
    } from 'devextreme-vue/validator';

    import {
        DxHtmlEditor,
        DxToolbar,
        DxMediaResizing,
        DxImageUpload,
        DxItem,
    } from 'devextreme-vue/html-editor';
    export default {
        name: 'FAQ',
        components: {

            DxAccordion,
            DxPopup,
            DxPosition,
            DxToolbarItem,
            DxTextBox,
            DxNumberBox,
            DxButton,
            DxSelectBox,
            DxValidator,
            DxRequiredRule,
            DxCustomRule,
            /*DxTextArea,*/
            DxCheckBox,
            DxHtmlEditor,
            DxToolbar,
            DxMediaResizing,
            DxImageUpload,
            DxItem,
            DxValidationGroup,
        },
        data() {
            return {
                btn: {
                    SaveBtn: this.$LanguageProvider.GetResource("SaveBtn", "Caption", "Save"),
                    ReleasedSelect: this.$LanguageProvider.GetResource("ReleasedSelect", "Caption", "Released"),
                    DeleteBtn: this.$LanguageProvider.GetResource("DeleteBtn", "Caption", "Delete"),
                    AddNewFaqBtn: this.$LanguageProvider.GetResource("AddNewFaqBtn", "Caption", "Add new Wiki Entry"),
                    EditFaqBtn: this.$LanguageProvider.GetResource("EditFaqBtn", "Caption", "Edit Wiki Entries"),
                },
                fagValue: null,
                editMode: false,
                fagName: '',
                addFaqVisible: false,
                areas: [{ FaaId: 0, FaaName: 'public' }, { FaaId: 1, FaaName: 'intern' }],
                FaaId: 1,
                faqData: {
                    FaqId: -1,
                    FagId: null,
                    FaqName: '',
                    FagName: '',
                        FaqAnswer: '',
                        FaqEnabled: false,
                        FaqDeleted: false,
                    groupsDataSource: new DataSource
                },
                addFaqButtonOptions: {
                    icon: 'fal fa-share-square',
                    text: 'Add',
                    useSubmitBehavior: true,
                    onClick: () => {
                        this.$refs.submitButton.$el.click();
                    }
                },
                cancelAddFaqOptions: {
                    icon: 'fal fa-ban',
                    text: 'Cancel',
                    onClick: () => {
                        this.addFaqVisible = false
                    }
                },
                validation: {
                    GroupRequired: this.$LanguageProvider.GetResource("Faq.GroupRequired", "Validation", "Please select or enter a group."),
                    TermRequired: this.$LanguageProvider.GetResource("Faq.TermRequired", "Validation", "Please enter a term/question."),
                    DescriptionRequired: this.$LanguageProvider.GetResource("Faq.DescriptionRequired", "Validation", "Please enter a description.")
                },
                placeholders: {
                    Group: this.$LanguageProvider.GetResource("Faq.GroupPlaceholder", "Caption", "Select or define a group..."),
                    Term: this.$LanguageProvider.GetResource("Faq.TermPlaceholder", "Caption", "Enter the term/question")
                }
            }
        },
        computed: {
            selectedFaaId() {
                return this.FaaId >= 0 ? this.FaaId : this.$store.state.faqStore.faaId
            },
            canEdit() {
                return this.editMode && this.isAdmin;
            },
            faqList() {
                var result = this.$store.state.faqStore.faqList;
                if (!this.isAdmin) {
                    return result.filter(m => m.FaqEnabled)
                }
                return result;
            },
            isAdmin() {
                return this.$store.state.faqStore.isAdmin;
            },
            groups() {
                if (!Array.isArray(this.faqList) || this.faqList.length === 0) {
                    return [];
                }
                // Build groups from faqList
                const groupedData = {};
                this.faqList.forEach(item => {
                    const key = item.FagId > 0 ? item.FagId : 0;
                    if (!groupedData[key]) {
                        groupedData[key] = [];
                    }
                    groupedData[key].push(item);
                });

                const groupsArr = Object.keys(groupedData).map(key => {
                    const group = groupedData[key];
                    const first = group[0];
                    return {
                        FagId: parseInt(key),
                        FagName: first.FagName,
                        FagPosition: first.FagPosition,
                        FagDeleted: false
                    };
                });
                // Sort by position (ascending), fallback to name
                return groupsArr.sort((a, b) => {
                    const posA = (typeof a.FagPosition === 'number' && !isNaN(a.FagPosition)) ? a.FagPosition : Number.MAX_SAFE_INTEGER;
                    const posB = (typeof b.FagPosition === 'number' && !isNaN(b.FagPosition)) ? b.FagPosition : Number.MAX_SAFE_INTEGER;
                    if (posA !== posB) return posA - posB;
                    return (a.FagName || '').localeCompare(b.FagName || '');
                });
            },
            accessList() {
                return this.$store.state.accessStore.accessList
            },
        },
        mounted() {
            this.$store.dispatch("getFaqList", -1);
            this.$store.dispatch("getAccessList", { tokenList: ["300621", "300622", "300624"] });
        },
        methods: {
            edit() {
                this.editMode = !this.editMode;
            },
            onGroupValueChanged(e) {
                // Keep fagName in sync with what the editor currently shows
                const currentText = (e?.component?.option('text') ?? '').toString();
                this.fagName = currentText;

                // If the editor is truly cleared (via clear button), also clear selection and id
                if (currentText === '') {
                    this.fagValue = null;
                    this.faqData.FagId = null;
                }

                // Revalidate against text
                this.$refs.groupValidator?.instance?.validate?.();
            },
            onGroupSelectionChanged(e) {
                // Keep text aligned with selected item, but do not create custom items here
                if (e && e.selectedItem) {
                    this.fagName = e.selectedItem.FagName;
                }
                this.$refs.groupValidator?.instance?.validate?.();
            },
            onCustomItemCreating(e) {
                // Accept current text as a transient custom item; do not insert into data source here
                const text = (e?.text ?? '').toString();
                if (!text.trim()) {
                    e.customItem = null;
                    return;
                }
                // Represent a transient item with a temporary id (null here; we set -1 on save)
                const custom = { FagId: null, FagName: text };
                this.fagValue = custom;
                this.fagName = text;
                // Do not set faqData.FagId yet; keep creation deferred to save
                e.customItem = custom;
            },
            getData(fagId) {
                return this.faqList.filter(m => { return m.FagId == fagId })
            },
            deleteFaq(faq) {
                let result = confirm("<i>Are you sure?</i>", "Confirm deletion");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        faq.FaqDeleted = true;
                        // Pass record: null so store does not push a blank FAQ (bug fix)
                        this.$store.dispatch("updateFaqList", { record: null, groups: null, faaId: this.selectedFaaId });
                    }
                });
            },
            deleteFag(fag) {
                let result = confirm("<i>Are you sure?</i>", "Confirm deletion");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        // Build payload including deletion flag for the selected group.
                        const groupsPayload = this.groups.map(g => ({
                            ...g,
                            FagDeleted: g.FagId === fag.FagId ? true : (g.FagDeleted || false)
                        }));
                        this.$store.dispatch("updateFaqList", { record: null, groups: groupsPayload, faaId: this.selectedFaaId });
                    }
                });
            },
            onSaveNewFaq(e) {
                // Always prevent native submit, we drive persistence ourselves.
                e.preventDefault();

                // Validate all fields inside the popup consistently
                const result = this.$refs.addFaqValidationGroup?.instance?.validate?.();
                if (!result || !result.isValid) {
                    // Keep popup open so the user can fix errors
                    this.addFaqVisible = true;
                    return;
                }

                // Persist text of custom group into payload for backend convenience
                this.faqData.FagName = (this.fagName || '').trim();

                // Defer group creation: if a numeric id exists, use it; otherwise, create a new group
                const hasNumericId = typeof this.faqData.FagId === 'number' && this.faqData.FagId >= 0;
                if (!hasNumericId && this.faqData.FagName) {
                    // Create new group record client-side with temporary id (-1)
                    // The store/backend should assign the real id upon save
                    this.faqData.FagId = -1;
                }

                this.$store.dispatch("updateFaqList", { record: this.faqData, groups: null, faaId: this.selectedFaaId });
                this.resetPopup();
                // Close popup after successful save
                this.addFaqVisible = false;
            },
            resetPopup() {
                this.faqData.FaqId = -1
                this.faqData.FagId = null
                this.faqData.FaqName = ''
                this.faqData.FagName = ''
                this.faqData.FaqAnswer = ''
                this.faqData.FaqEnabled = false
                this.faqData.FaqDeleted = false
            },
            update() {
                // For updates send current groups list (exclude transient deletion flags unless explicitly set)
                const groupsPayload = this.groups.map(g => ({ ...g }));
                this.$store.dispatch("updateFaqList", { record: null, groups: groupsPayload, faaId: this.selectedFaaId });
            },
            // Removed early custom item creation; creation happens when saving if needed
            updateFaqList() {
                this.addFaqVisible = true
            },
        },
        watch: {
            FaaId: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.$store.dispatch("getFaqList", newVal);
                }
            }
        },
    }

</script>
<style scoped>
    .btn-add-edit {
        margin-bottom: 10px;
        display: flex;
        column-gap: 20px;
    }
    .faqPage {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .btn-html-editor {
        display: grid;
    }

    .faqDeleted, .faqSave {
        margin-left: -8px;
    }

    .faqEnabled {
        padding-bottom: 6px;
    }

    .faqPage .faqGroupTitle, .faqPage .faqGroupTitle input {
        padding: 20px 0 0 0;
        font-size: 21px;
        font-weight: bold;
    }

    .faqPage .faqRecord {
        display: flex;
        align-items: baseline;
        gap: 12px;
    }

    .faqPage .faqNameRecord {
        display: grid;
        grid-template-columns: 50px auto;
    }

    .faqPage .fagRecord {
        display: grid;
        gap: 20px;
        grid-template-columns: 50px auto max-content;
        align-items: baseline;
        /* justify-content: stretch; */
        /* width: 100%; */
    }

    .faqPage .faqPosition .dx-texteditor.dx-editor-filled .dx-texteditor-input {
        margin: 0;
        padding: 5px 5px 2px 28px;
    }

    .faqPage .faqAnswer {
        width: 100%;
    }

    .faqPage .faqName .dx-texteditor.dx-editor-filled .dx-texteditor-input {
        margin: 0;
        padding: 5px 5px 2px 5px;
    }

    .faqPage .dx-item-content.dx-accordion-item-title {
        min-height: 48px;
        height: auto;
    }
    .faq {
        margin-top: 20px;
    }
    @media only screen and (max-width: 600px) {
        span.dx-button-text {
            display: none;
        }
    }
    .btn-add-edit {
        column-gap: 10px;
    }
</style>